import { useEffect, useRef } from "react";
import { MsalProvider } from "@azure/msal-react";

import { msalInstance } from "@/lib/auth";
import { getEmbedConfig } from "@/lib/embed/config";
import { applyAccent } from "@/lib/embed/theme";
import { useEmbedBridge } from "@/lib/embed/useEmbedBridge";
import ChatInterface from "@/components/ChatInterface";
import EmbedAuthGate from "@/components/embed/EmbedAuthGate";
import EmbedLayout from "@/components/embed/EmbedLayout";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";

/**
 * Minimal, chrome-less shell for embedded (portal iframe) mode: chat only,
 * no router / sidebar / header / history. Applies the default accent and runs
 * the postMessage bridge on mount; the auth gate then handles silent SSO /
 * popup sign-in and fetches config (which needs a token) once authenticated.
 */
export default function EmbedApp() {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    applyAccent(getEmbedConfig().defaultAccent);
  }, []);

  useEmbedBridge(rootRef);

  return (
    <TooltipProvider>
      <MsalProvider instance={msalInstance}>
        <EmbedLayout ref={rootRef}>
          <EmbedAuthGate>
            <ChatInterface />
          </EmbedAuthGate>
        </EmbedLayout>
      </MsalProvider>
      <Toaster />
    </TooltipProvider>
  );
}
